import { create } from "zustand";

interface FilterState {
  filters: Record<string, any>;
  setFilters: (filters: FilterState["filters"]) => void;
  resetFilters: () => void;
}

const defaultFilters: FilterState["filters"] = {
  query: { value: "", matchMode: "contains" },
  title: {value: "", matchMode: "contains" },
  description: {value: "", matchMode: "contains" },
  createdAt: {value: "", matchMode: "contains" },
  modifiedAt: {value: "", matchMode: "contains" }
};

export const useFilterFormTemplateStore = create<FilterState>((set) => ({
  filters: defaultFilters,
  setFilters: (filters) => set({ filters }),
  resetFilters: () => set({ filters: defaultFilters }),
}));